import { render, staticRenderFns } from "./BaseCarousel.vue?vue&type=template&id=921f9c46"
import script from "./BaseCarousel.vue?vue&type=script&lang=js"
export * from "./BaseCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports